<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="household_number">Household Number</label>
                <input type="text"
                        v-model="search_data.household_number" id="household_number" name="household_number"
                        class="form-control form-control-sm"
                        placeholder="Search by HH No"/>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="name">Household Head Name</label>
                <input type="text" v-model="search_data.name" id="name"  name="name"
                  class="form-control form-control-sm" placeholder="Search by Name"
                />
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="c_village_id">Village</label>
                <select
                  v-model="search_data.c_village_id"
                  name="c_village_id"
                  id="c_village_id"
                  class="form-control form-control-sm"
                >
                  <option selected :value="''">Select a village</option>
                  <option
                    v-for="(village, index) in villages"
                    :key="index"
                    :value="village.id"
                    >{{ village.id }} : {{ village.desc }}</option
                  >
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="c_mouza_id">Mouza</label>
                <select
                        v-model="search_data.c_mouza_id"
                        class="form-control form-control-sm"
                        name="c_mouza_id"
                        id="c_mouza_id"
                >
                  <option selected :value="''">Select a Mouza</option>
                  <option
                          v-for="(mouza, index) in mouzas"
                          :key="index"
                          :value="mouza.id"
                  >{{ mouza.id }} : {{ mouza.desc }}</option
                  >
                </select>
              </div>
            </div>
            <button class="btn btn-success btn-sm mt-2"  @click.prevent="search">Search</button>
          </form>
        </b-card>

        <b-card>
          <div class="row mb-2">
            <div class="col-sm-12">
              <div v-if="lands.total > 0">
                <span class="badge badge-success">Total Search Data Found: {{ lands.total }}</span>
                <download-excel
                        class = "btn btn-light float-right"
                        :fetch = "fetchData"
                        :fields = "land_fields"
                        :meta="json_meta"
                        worksheet = "Land"
                        name = "land.xls">
                  Download Excel
                </download-excel>
                <button class="btn btn-light float-right mr-1" @click="dowonloadPdf">
                  <div v-if="loading" class="spinner-border spinner-border-sm text-muted" style="margin-bottom : 2px;">
                  </div>
                  Download PDF
                </button>
              </div>
            </div>
          </div>

          <div class="table-responsive" style="overflow-x: auto">
              <table class="table table-centered table-striped">
                <thead>
                <tr>
                  <th>#</th>
                  <th>land Type</th>
                  <th>Mouza</th>
                  <th>Plot No.</th>
                  <th>Khatian No</th>
                  <th>Total Land</th>
                  <th>Aquired Land</th>
                  <th>Land Ownership</th>
                  <th>LA Case</th>
                  <th>CCL Amount</th>
                  <th>Book/Sub Book</th>
                  <th>Cheque No.</th>
                  <th>Cheque Date</th>
                  <th>Village</th>
                </tr>
                </thead>
                <tbody>
                <tr li v-for="(land, index) in lands.data" :key="index">
                  <td>{{ lands.from + index }}</td>
                  <td>{{ land.land_type.desc }}</td>
                  <td>{{ land.mouza.desc }}</td>
                  <td>{{ land.plot_no }}</td>
                  <td>{{ land.khatian_no }}</td>
                  <td>{{ land.total_land }}</td>
                  <td>{{ land.acquired_land }}</td>
                  <td>{{ land.land_ownership.desc }}</td>
                  <td>{{ land.la_case.desc }}</td>
                  <td>{{ land.ccl_amount }}</td>
                  <td>{{ land.book_no }}/{{ land.book_sub_no }}</td>
                  <td>{{ land.cheque_no }}</td>
                  <td>{{ land.cheque_date }}</td>
                  <td>{{ land.ses.village.desc }}</td>
                </tr>
                </tbody>
              </table>
              <h5 v-if="!flag || lands.total == 0" class="text-center text-secondary">
                No Data Found
              </h5>
              <div class="float-right mt-1">
                <pagination :data="lands" :limit="2" @pagination-change-page="getResults"></pagination>
              </div>
          </div>

        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default {
  page: {
    title: "List SES Land",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Search SES Land",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "SES Land",
          active: true
        }
      ],
      loading: false,
      lands: {},
      search_data: {
        household_number: '',
        name: '',
        c_village_id: '',
        c_mouza_id: '',
      },
      villages: [],
      mouzas: [],
      land_fields: {
        'land Type': 'land_type.desc',
        'Plot No.': 'plot_no',
        'Khatian No': 'khatian_no',
        'Total Land': 'total_land',
        'Aquired Land': 'acquired_land',
        'Land Ownership': 'land_ownership.desc',
        'LA Case': 'la_case',
        'CCL Amount': 'ccl_amount',
        'Book/Sub Book' : {
          callback: (value) => {
            return `${value.book_no} / ${value.book_sub_no}`;
          }
        },
        'Cheque No.': 'cheque_no',
        'Cheque Date': 'cheque_date',
        'Village': 'ses.village.desc',
        'Mouza': 'ses.mouza.desc',
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      flag: false
    };
  },

  mounted() {
    this.getCodes();
  },
  methods: {
    async dowonloadPdf() {
      this.loading = true
      let response = await http.post("api/ses/land/download", this.search_data);
      var data = []
      try {
        response.data.lands.forEach(function (value) {
          data.push([
            value.land_type.desc,
            value.plot_no,
            value.khatian_no,
            value.total_land,
            value.acquired_land,
            value.land_ownership.desc,
            value.la_case,
            value.ccl_amount,
            value.book_no + '/' + value.book_sub_no,
            value.cheque_no,
            value.cheque_date,
            value.ses.village.desc,
            value.ses.mouza.desc
          ])
        })
      }
      catch (e) {
        console.log(e.message)
      }

      const doc = new jsPDF({ orientation: 'l'})
      autoTable(doc, {
        head: [['Land Type', 'Plot no', 'Khatian no', 'Total land', 'Acquired land', 'Land ownership', 'LA Case', 'CCL Amount', 'Book/Sub book', 'Cheque no', 'Cheque date', 'Village', 'Mouza']],
        body: data,
      })
      doc.save('ses-land-report.pdf')
      this.loading = false
    },
    getCodes() {
      http.get("api/ses/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.villages = data.villages;
          this.mouzas = data.mouzas;
        }
      });
    },
    search() {
      http.post("api/ses/land/search", this.search_data).then(response => {
        if (!response.error) {
          this.flag = true;
          this.lands = response.data.lands;
        }
      });
    },
    getResults(page = 1) {
      http.post('api/ses/land/search?page=' + page, this.search_data)
              .then(response => {
                this.flag = true;
                this.lands = response.data.lands;
              });
    },
    async fetchData(){
      const response = await http.post("api/ses/land/download", this.search_data);
      return response.data.lands;
    },
  },
};
</script>
